import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminSignedDocuments = ({ token, apiCall }) => {
  const [staffDocs, setStaffDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      const data = await apiCall('/admin/signed-documents', 'GET', null, token);
      setStaffDocs(data || []);
    } catch {
      toast.error('Failed to load signature statuses');
    }
    setLoading(false);
  }, [apiCall, token]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <p className="text-slate-500 text-sm p-4">Loading signature statuses...</p>;

  return (
    <div className="space-y-4" data-testid="admin-signed-documents-panel">
      <Card>
        <CardHeader>
          <CardTitle>Staff Document Signatures</CardTitle>
          <p className="text-sm text-slate-500">DBS Declaration signing status for each staff member. Terms of Engagement, KID and Application Form are handled manually (previously signed copies remain visible).</p>
        </CardHeader>
        <CardContent className="space-y-4">
          {staffDocs.length === 0 && <p className="text-slate-500 text-sm">No staff members found.</p>}
          {staffDocs.map((staff) => (
            <div key={staff.user_id} className="border rounded-lg p-4" data-testid={`staff-docs-${staff.user_id}`}>
              <div className="flex items-center justify-between mb-3">
                <div>
                  <p className="font-semibold">{staff.name}</p>
                  <p className="text-xs text-slate-500">{staff.email}</p>
                </div>
                {staff.all_signed ? (
                  <Badge className="bg-green-600">All Signed ✓</Badge>
                ) : (
                  <Badge className="bg-orange-500">
                    {staff.documents.filter(d => !d.signed).length} pending
                  </Badge>
                )}
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {staff.documents.map((doc) => (
                  <div
                    key={doc.document_type}
                    className={`p-3 rounded border text-sm ${doc.signed ? 'bg-green-50 border-green-200' : 'bg-slate-50 border-slate-200'}`}
                  >
                    <p className="font-medium text-xs mb-1">{doc.name}</p>
                    {doc.signed ? (
                      <>
                        <p className="text-xs text-green-700">
                          ✓ {new Date(doc.signed_at).toLocaleDateString('en-GB')} {new Date(doc.signed_at).toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })}
                        </p>
                        <p className="text-xs text-slate-500">IP: {doc.ip_address}</p>
                        <a
                          href={`${BACKEND_URL}${doc.pdf_url}?token=${token}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-xs text-teal-700 underline font-medium"
                          data-testid={`admin-download-pdf-${staff.user_id}-${doc.document_type}`}
                        >
                          📄 Download PDF
                        </a>
                      </>
                    ) : (
                      <p className="text-xs text-orange-600">Not signed yet</p>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
        </CardContent>
      </Card>
    </div>
  );
};
